/* The compact mobile link returns shoppers to the native product controls. */
if (!customElements.get('le-pdp-purchase-link')) {
  customElements.define('le-pdp-purchase-link', class extends HTMLElement {
    connectedCallback() {
      document.body.classList.add('le-pdp-refined');
      this.updateVisibility = () => {
        if (this.pendingFrame) return;
        this.pendingFrame = requestAnimationFrame(() => {
          this.pendingFrame = null;
          const purchaseButton = document.querySelector('.le-pdp-native [data-add-to-cart]');
          this.hidden = !purchaseButton || purchaseButton.getBoundingClientRect().bottom > 0;
        });
      };
      window.addEventListener('scroll', this.updateVisibility, { passive: true });
      window.addEventListener('resize', this.updateVisibility);
      window.addEventListener('pageshow', this.updateVisibility);
      this.updateVisibility();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateVisibility);
      window.removeEventListener('resize', this.updateVisibility);
      window.removeEventListener('pageshow', this.updateVisibility);
      if (this.pendingFrame) cancelAnimationFrame(this.pendingFrame);
      this.pendingFrame = null;
      document.body.classList.remove('le-pdp-refined');
    }
  });
}
